export const WALLET_ROUTES = ["/wallet", "/wallet/collection", "/wallet/products"];
export const MARKETING_PROMOTION_ROUTES = [
  "/marketingPromotionManagement",
  "/marketingPromotionManagement/accompaniment_Module"
];
export const DIRECTOR_GESTION_ROUTES = [
  "/management_direction",
  "/management_direction/banner_admin",
  "/riskAndOpportunityManagement",
  "/interestedParties"
];
export const MANAGEMENT_HEADER_ROUTES = [
  "/",
  "/management_direction",
  "/management_direction/banner_admin"
];
export const NO_BUTTONS_ROUTES = ["/superior_rol_dashboard", "/self_appraisal"];
export const FULL_BUTTONS_ROUTES = [
  "/",
  "/management_direction",
  "/management_direction/banner_admin"
];
export const BASIC_BUTTONS_ROUTES = [
  "/dashboard",
  "/clients",
  "/clients/topClients",
  "/clients/topProducts",
  "/interestedParties",
  "/biomedicalManagementDashboard",
  "/biomedicalManagementDashboard/biomedicalAdminPage",
  "/biomedicalManagementDashboard/indicator",
  "/biomedicalManagementDashboard/manageDevice",
  "/biomedicalManagementDashboard/BioMedicalRequest",
  "/biomedicalManagementDashboard/BioMedicalRequest/createRequest",
  "/biomedicalManagementDashboard/serviceRecords",
  "/riskAndOpportunityManagement"
];

export const isWalletRoute = (pathname) =>
  WALLET_ROUTES.includes(pathname) || pathname?.startsWith("/wallet/");

export const isMarketingPromotionRoute = (pathname) =>
  MARKETING_PROMOTION_ROUTES.includes(pathname) ||
  pathname?.startsWith("/marketingPromotionManagement/");

export const isDirectorGestionRoute = (pathname) =>
  DIRECTOR_GESTION_ROUTES.includes(pathname) ||
  pathname?.startsWith("/management_direction/") ||
  pathname?.startsWith("/riskAndOpportunityManagement/");

export const isManagementHeaderRoute = (pathname) =>
  MANAGEMENT_HEADER_ROUTES.includes(pathname);

export const isNoButtonsRoute = (pathname) =>
  NO_BUTTONS_ROUTES.includes(pathname);

export const isFullButtonsRoute = (pathname) =>
  FULL_BUTTONS_ROUTES.includes(pathname);

export const isBasicButtonsRoute = (pathname) =>
  BASIC_BUTTONS_ROUTES.includes(pathname);

export const syncHeaderButtonStates = (pathname, dispatch, actions) => {
  const {
    changeWalletBtnState,
    changeMarketingPromotionManagementBtnState,
    changeDirectorGestionBtnState,
    changeManagementHeaderBtnState
  } = actions;

  changeWalletBtnState &&
    dispatch(changeWalletBtnState(isWalletRoute(pathname)));
  changeMarketingPromotionManagementBtnState &&
    dispatch(
      changeMarketingPromotionManagementBtnState(
        isMarketingPromotionRoute(pathname)
      )
    );
  changeDirectorGestionBtnState &&
    dispatch(changeDirectorGestionBtnState(isDirectorGestionRoute(pathname)));
  changeManagementHeaderBtnState &&
    dispatch(changeManagementHeaderBtnState(isManagementHeaderRoute(pathname)));
};
